import { motion } from "framer-motion";

const FeatureCard = ({ icon: Icon, title, description, color, index, metric, tags, layout }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.08, duration: 0.55 }}
      whileHover={{ y: -8, scale: 1.01 }}
      className={`group relative ${layout}`}
    >
      {/* Outer Glow Backdrop */}
      <div
        className="absolute inset-0 rounded-[30px] opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-100 pointer-events-none"
        style={{
          background: `radial-gradient(circle at top, ${color}20, transparent 65%)`,
        }}
      />

      {/* Main Card */}
      <div
        className="relative h-full overflow-hidden rounded-[30px] border border-white/10 bg-[linear-gradient(165deg,rgba(15,22,48,0.92),rgba(11,18,37,0.85))] p-7 shadow-[0_24px_60px_rgba(2,6,23,0.4)] backdrop-blur-2xl sm:p-8"
        style={{
          animation: `float-slow ${6.5 + index * 0.7}s ease-in-out ${index * 0.35}s infinite`,
        }}
      >
        {/* Glow corner */}
        <div
          className="absolute -right-8 -top-8 w-24 h-24 rounded-full opacity-0 group-hover:opacity-20 blur-2xl transition-opacity duration-500"
          style={{ background: color }}
        />

        {/* Top line accent */}
        <div
          className="absolute top-0 left-0 right-0 h-px"
          style={{
            background: `linear-gradient(90deg, transparent, ${color}, transparent)`,
          }}
        />

        <div className="relative z-10 flex items-start justify-between gap-4">
          {/* Icon */}
          <div
            className="flex h-14 w-14 items-center justify-center rounded-2xl"
            style={{
              background: `${color}15`,
              border: `1px solid ${color}35`,
              boxShadow: `0 0 24px ${color}10`,
            }}
          >
            <Icon
              className="h-7 w-7"
              style={{
                color: color,
                filter: `drop-shadow(0 0 10px ${color})`,
              }}
            />
          </div>

          {/* Metric Pill */}
          {metric && (
            <span
              className="rounded-full border px-3 py-1.5 text-[11px] font-semibold tracking-[0.2em] uppercase"
              style={{
                color: color,
                borderColor: `${color}35`,
                background: `${color}08`,
              }}
            >
              {metric}
            </span>
          )}
        </div>

        {/* Title */}
        <h3
          className="mt-8 text-2xl font-semibold text-white sm:text-[1.8rem]"
          style={{ fontFamily: '"Space Grotesk", sans-serif' }}
        >
          {title}
        </h3>

        {/* Description */}
        <p className="mt-4 text-[0.95rem] leading-7 text-[#A7B1D0]">
          {description}
        </p>

        {/* Tags */}
        {tags && tags.length > 0 && (
          <div className="mt-6 flex flex-wrap gap-2.5">
            {tags.map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-semibold tracking-wider text-slate-300 uppercase"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default FeatureCard;
